import Vue from 'vue'
import Router from 'vue-router'

//车辆 管理///////////////////////////////
const caritembase = () => import("@/components/store_car/item_base"); //物品基础信息

const caritemclass = () => import("@/components/store_car/item_class"); //物品分类
const caritemunit = () => import("@/components/store_car/item_unit"); //物品单位
const caritemfrom = () => import("@/components/store_car/item_from"); //物品供应商
const carstore = () => import("@/components/store_car/store_build"); //仓库建立

const store_in = () => import("@/components/store_car/store_in"); //入库单
const store_from_to = () => import("@/components/store_car/store_from_to"); //转移单
const store_apply = () => import("@/components/store_car/store_apply"); //申请单
const store_rec = () => import("@/components/store_car/store_rec"); //领用单
const store_other = () => import("@/components/store_car/store_other"); //其他单
const store_buy = () => import("@/components/store_car/store_buy"); //采购单

const store_check = () => import("@/components/store_car/store_check"); //盘点单
const store_check_pass = () => import("@/components/store_car/store_pass"); //盘点审核单


const tab_sheet_qty = () => import("@/components/store_car/tab_store_sheetno"); //单据库存
const tab_pi_qty = () => import("@/components/store_car/tab_store_pi"); //批次库存
const tab_time_qty = () => import("@/components/store_car/tab_store_time"); //实时库存



Vue.use(Router)

export default[
	{
		name: "caritembase",
		path: "/caritembase",
		component: caritembase,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "物品基本信息"
		}
	},
	{
		name: "caritemclass",
		path: "/caritemclass",
		component: caritemclass,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "物品分类"
		}
	},
	{
		name: "caritemunit",
		path: "/caritemunit",
		component: caritemunit,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "物品单位"
		}
	},
	{
		name: "caritemfrom",
		path: "/caritemfrom",
		component: caritemfrom,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "供应商"
		}
	},
	{
		name: "carstore",
		path: "/carstore",
		component: carstore,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "仓库建立"
		}
	},
	{
		name: "store_in",
		path: "/store_in",
		component: store_in,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "入库单"
		}
	},
	{
		name: "store_from_to",
		path: "/store_from_to",
		component: store_from_to,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "转移单"
		}
	},
	{
		name: "store_apply",
		path: "/store_apply",
		component: store_apply,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "申请单"
		}
	},
	{
		name: "store_rec",
		path: "/store_rec",
		component: store_rec,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "领用单"
		}
	},
	{
		name: "store_other",
		path: "/store_other",
		component: store_other,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "其他单"
		}
	},
	{
		name: "store_buy",
		path: "/store_buy",
		component: store_buy,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "采购单"
		}
	},
	////////////////////////////////////////////////////////
	{
		name: "store_check",
		path: "/store_check",
		component: store_check,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "盘点单"
		}
	},
	{
		name: "store_check_pass",
		path: "/store_check_pass",
		component: store_check_pass,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "盘点审核单"
		}
	},
	{
		name: "tab_sheet_qty",
		path: "/tab_sheet_qty",
		component: tab_sheet_qty,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "单据库存"
		}
	},
	{
		name: "tab_pi_qty",
		path: "/tab_pi_qty",
		component: tab_pi_qty,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "批次库存"
		}
	},
	{
		name: "tab_time_qty",
		path: "/tab_time_qty",
		component: tab_time_qty,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "实时库存"
		}
	}
	
]